import { useEffect, useState } from 'react';
import appFirebase from "../../utils/firebase/credentials";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { Portafolio } from './Portafolio';
import skills from '../../utils/data-fernandoc/skills-fernando.json';
import { Loader } from '../utils/Loader';

const db = getFirestore(appFirebase);

export function PagePortfolio() {

    const [profiles, setProfiles] = useState([]);
    const [posts, setPosts] = useState([]);
    const [projects, setProjects] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getList = async (nameDB, setData) => {
        try {
            const querySnapshot = await getDocs(collection(db, nameDB));
            const docs = [];
            querySnapshot.forEach((doc) => {
                docs.push({ ...doc.data(), id: doc.id });
            });
            setData(docs);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            await getList('profiles', setProfiles);
            await getList('postsFernandoC', setPosts);
            await getList('projectsFernandoC', setProjects);
            setIsLoading(false);
        };

        fetchData();
    }, []);

    return (
        <div className='page-portfolio w-100'>
            {   
                isLoading ? (
                    <Loader />
                ):
                profiles.map((profile, index) => (
                    <Portafolio
                        key={index}
                        profile={profile}
                        posts={posts}
                        projects={projects}
                        skills={skills} />
                ))
            }
        </div>
    );
}